import React,{useRef,useEffect,useState} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import {format,parseISO,parse} from 'date-fns';
import Slide from '@mui/material/Slide';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import { createTheme } from "@mui/material";


const drawerWidth = 300;



const materialTheme = createTheme(({
    // set default for now
  }));


const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    appBar: {
        position: 'fixed',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
  fullWidth: {
    width: "100%"
  },
}));



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ForDeliveriesInformation (props)
{
    const classes = useStyles();

    function formatDate(dateString){
        try {
          return format(parseISO(dateString), 'yyyy-MM-dd')
        }catch(err){
          return ""
        }
        
    }
    

    
    const computeTotalSalesOrderAmount = () => {
        if(props.selectedSalesOrder.salesOrderItems === null || props.selectedSalesOrder.salesOrderItems === undefined){
            return;
        }

        const totalInvoicedValue = Number(props.selectedSalesOrder.salesOrderItems.reduce((partialSum,product)=>{

            return partialSum + (product.price_with_tax * product.order_quantity)


        },0 ))

        return totalInvoicedValue
    }
    
    const computeTotalSalesOrderDeliveredAmount = () => {
        if(props.selectedSalesOrder.salesOrderDeliveredItems === null || props.selectedSalesOrder.salesOrderDeliveredItems === undefined){
            return;
        }

        const totalInvoicedValue = Number(props.selectedSalesOrder.salesOrderDeliveredItems.reduce((partialSum,product)=>{

            return partialSum + (product.price_with_tax * product.order_quantity)


        },0 ))

        return totalInvoicedValue
    }

    const productLists = () => {
        return (
            <List>
                {
                    props.selectedSalesOrder.salesOrderDeliveredItems.map(product => (
                        <React.Fragment key={product.id}>
                            <ListItem >
                                {productElement(product)}
                            </ListItem>
                            <Divider light />
                        </React.Fragment>
                    )
                    )
                }
            </List>
        )
    }

    const productElement = (product) => {
        return (
            <Grid container style={{ padding: "0px" }}>
                <Grid container item xs={12} >
                    < Grid item xs={3} md={2} lg={2} style={{ padding: "4px" }} container
                        spacing={0}
                        direction="column"
                        alignItems="center"
                        justifyContent="center">
                             <img 
                                src={product.image} 
                                style={{ width:"100%"}}  
                                onError={(event) => {
                                    event.currentTarget.onerror = null; // prevents looping
                                    event.currentTarget.src="https://transacti.tradynamics.com/img/no-image-available.jpg";
                                }}
                            />
                    </Grid>
                    <Grid item xs={9} md={8} lg={8}>
                        <Grid
                            container
                            direction="column"
                            justifyContent="space-between"
                            alignItems="stretch">
                            <Grid item >
                                <Box style={{ fontWeight: 600, fontSize: "14px" }}>{product.brand}</Box>
                                <Box style={{ fontWeight: 600, fontSize: "14px" }}>{product.product_name}</Box>

                            </Grid>
                            <Grid item >
                                <Box display="flex" justifyContent="flex-end" >
                                    <Typography variant="h6" component="span" style={{ fontWeight: 600, fontSize: "16px",color: "green" }}>
                                     ₱ {product.price_with_tax} x {product.order_quantity} {product.uom} =  {Number((product.price_with_tax * product.order_quantity).toFixed(2)).toLocaleString('en-US', {maximumFractionDigits:2})}

                                     </Typography>
                                </Box>

                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    function mainContent(){
        return (
          <React.Fragment>
            <div style={{padding:'.25rem'}}>
              <Grid container spacing={1} style={{padding:'.25rem'}}>
                  <Grid item xs={12} sm={8} md={10} lg={10} className={classes.rightLabel} >
                      <Box
                          sx={{
                              display: 'flex',
                              alignItems:"center",
                              justifyContent:"center",
                              '& > :not(style)': {
                              m: 1,
                              width: 200,
                              height: 200,
                              },
                          }}>
                          
                          <label htmlFor="icon-button-file" > 
                              <Paper elevation={3}
                                  style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      height:"100%",
                                      padding:"40px",
                                  }}
                              >
                               <img
                                    width={200}
                                    height={200}
                                    src={props.selectedSalesOrder.image}
                                    // src={URL.createObjectURL(props.selectedSalesOrder.image)}
                                    loading="lazy"
                                    onError={(event) => {
                                        event.currentTarget.onerror = null; // prevents looping
                                        event.currentTarget.src="https://transacti.tradynamics.com/img/no-image-available.jpg";
                                    }}
                                />
                              </Paper>
                          </label>
                      </Box>
                  </Grid>
                  
              </Grid>
              
              <Grid container spacing={1} style={{padding:'.50rem'}}>
                    <Grid item xs={12}  sm={12}  md={12} lg={12} className={classes.leftLabel} style={{ fontWeight: '500' }}>
                            P.O Number :   {props.selectedSalesOrder.po_number}
                    </Grid>
                    <Grid item xs={12}  sm={12}  md={12} lg={12} className={classes.leftLabel} style={{ fontWeight: '500' }}>
                            P.O Date :  {formatDate(props.selectedSalesOrder.po_datetime)}
                    </Grid>
                    <Grid item xs={12}  sm={12}  md={12} lg={12} className={classes.leftLabel} style={{ fontWeight: '500' }}>
                            Request Delivery Date :  {formatDate(props.selectedSalesOrder.request_delivery_date)}  
                    </Grid>
                    <Grid item xs={12}  sm={12}  md={12} lg={12} className={classes.leftLabel} style={{ fontWeight: '500' }}>
                            Account Name:   {props.selectedSalesOrder.account_name}
                    </Grid>
                    <Grid item xs={12}  sm={12}  md={12} lg={12} className={classes.leftLabel} style={{ fontWeight: '500' }}>
                            Owner Name:   {props.selectedSalesOrder.salesman_first_name}  {props.selectedSalesOrder.salesman_middle_name}  {props.selectedSalesOrder.salesman_last_name}
                    </Grid>
                    <Grid item xs={12}  sm={12}  md={12} lg={12} className={classes.leftLabel} style={{ fontWeight: '500' }}>
                            Delivered Value: {Number((computeTotalSalesOrderDeliveredAmount()).toFixed(2)).toLocaleString('en-US', {minimumFractionDigits:2})}  
                    </Grid>
                    <Grid item xs={12}  sm={12}  md={12} lg={12} className={classes.leftLabel} style={{ fontWeight: '500' }}>
                            Order Value: {Number((computeTotalSalesOrderAmount()).toFixed(2)).toLocaleString('en-US', {minimumFractionDigits:2})}  
                    </Grid>
              </Grid>
                <Divider light />
                {productLists()}
        
              <br /><br /><br /> 
              </div>
          </React.Fragment>
        );
    }

    return (
        <div>
            
           <Dialog 
            fullScreen 
            open={props.openOrdersInfoDialog} 
            onClose={()=>{props.setProductAction("add")}} 
            TransitionComponent={Transition}
            >
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={()=>{
                            
                            props.setSelectedSalesOrder(null)
                            props.setOpenOrdersInfoDialog(false)
                            
                        }
                            
                            
                        }
                        aria-label="close"
                        size="large">
                    <CloseIcon />
                    </IconButton>
                    <Typography variant="subtitle1" className={classes.title}>
                        Delivery<br/><small>{props.selectedSalesOrder.account_name}</small>
                    </Typography>
                </Toolbar>
            </AppBar>
            <div className={classes.appBarSpacer}></div>
            <div style={{padding:'.5rem'}}>
                
                {mainContent()}
            </div>
      </Dialog>
        </div>
    )
}